export default __webpack_public_path__ + "static/media/Freeze.3eb8cca0.png";